import React from 'react';
import ReactDOM from 'react-dom/client';
import 'flowbite';
import App from './App';
import { AuthProvider } from './libraries/AuthContext';
import { AppProvider } from './libraries/AppContext';
import { SocketProvider } from './libraries/SocketContext';
import * as Sentry from "@sentry/react";
import { initializeApp } from './libraries/appUpdate';


// Only initialize Sentry in production
if (import.meta.env.PROD) {
  Sentry.init({
    dsn: "https://2a19529de494802c254dc2c069246637@o4508000803028992.ingest.de.sentry.io/4510324989689936",
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true
  });
}

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <AuthProvider>
      <AppProvider>
        <SocketProvider>
          <App />
        </SocketProvider>
      </AppProvider>
    </AuthProvider>
  </React.StrictMode>
);
